


export function pushState(state) {
	if (!state || window.history.state === state) {
		return;
	}
	window.history.pushState(state, '');
}
